import { Box, Button, Flex, Heading, Skeleton, Spacer } from '@chakra-ui/react';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';
import React from 'react';
import { useHistory, Link } from 'react-router-dom';

import {
  FundingRequestStatusEnumGQLType,
  useGetUserActiveCreditFacilitiesQuery,
} from 'types/dashboard-core-gqlTypes.generated.d';

import { colors } from 'packages/common-frontend/colors';
import { dashboardRoutePadding } from 'packages/common-frontend/constants';
import { FundingRequestHistoryViewContainer } from 'packages/funding-requests/ui/history/ViewContainer';
import { baseNewVerificationUrl } from 'packages/verifications/ui/VerificationsTemplate';
import { VerificationTrackerTable } from 'packages/verifications/ui/VerificationTrackerTable';

const allowedStatuses: FundingRequestStatusEnumGQLType[] = [
  'approved',
  'submitted',
  'canceled',
  'expired',
  'rejected',
];

export const FundingRequestHistoryWithVerificationRoute: React.FC<{
  enableVerifications: boolean;
}> = withLDConsumer()(({ flags, enableVerifications }) => {
  const history = useHistory();

  const {
    data: userData,
    loading: userLoading,
  } = useGetUserActiveCreditFacilitiesQuery({
    variables: {
      creditFacilitySlugsToHide: flags?.creditFacilitySlugsToHide ?? [],
    },
  });

  if (!userData || !userData.user || userLoading) {
    return <Skeleton data-testid="loading-statements-view" height="600px" />;
  }
  const {
    user: {
      organization: { creditFacilities },
    },
  } = userData;

  return (
    <Box padding={dashboardRoutePadding}>
      <Flex>
        <Heading as="h2" mb="36px">
          Funding Requests
        </Heading>
        <Spacer />
        {enableVerifications && (
          <Box>
            <Button
              backgroundColor={colors.aurora[900]}
              color="white"
              onClick={() => {
                history.push(baseNewVerificationUrl);
              }}
            >
              Start Verification
            </Button>
          </Box>
        )}
      </Flex>
      {enableVerifications && (
        <Box>
          <VerificationTrackerTable
            organizationId={userData.user.organizationId}
          />
          <Box height="32px" />
        </Box>
      )}
      <FundingRequestHistoryViewContainer
        allowedStatuses={allowedStatuses}
        activeCreditFacilities={creditFacilities}
      />
      {enableVerifications && (
        <Box mt="32px" mb="16px" textAlign="right">
          <Link to="/funding-requests/verifications/pipeline/history">
            View all verification reports
          </Link>
        </Box>
      )}
    </Box>
  );
});
